export default {
  headerHeight: '40px',
  actionButtonsContainer: '332px',
  buttonHeight: '38px',
  buttonMinWidth: '38px',
  inputBorderRadius: '19px',
};
